const MIN_PUBLISHER_CAP = 0;
const ERROR_MESSAGES = {
    INSUFFICIENT_TOTAL: "Publisher caps are missing. Publisher caps must be between 0-100.00%"
};
export const validators = {
    pubCapPct: (item, value) => {
        if (value === undefined || typeof value !== "number" || value < MIN_PUBLISHER_CAP) {
            return ERROR_MESSAGES.INSUFFICIENT_TOTAL;
        }
        return undefined;
    }
};
//# sourceMappingURL=validators.js.map